import get from 'lodash/get'
import {
  FETCH_ACTIVE_RESOURCES,
  CHECK_IN_ALL_RESOURCES,
  CHECK_IN_SINGLE_RESOURCES,
  CHECK_IN_MULTIPLE_RESOURCES,
  DISABLE_RESOURCES_IDENTITY,
} from '../../actions'

import { checkinAllStatusUpdate } from './utils'

const initialState = {
  loading: false,
  isCheckingInAllResources: false,
  isCheckingInMultipleResources: false,
  isCheckingInSingleResources: false,
  error: null,
  data: [],
  selectedUser: {},
  hasMoreData: false,
  totalCount: 0,
}

export function activeResources(state = initialState, action) {
  switch (action.type) {
    case `${FETCH_ACTIVE_RESOURCES}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null,
      }
    }

    case `${FETCH_ACTIVE_RESOURCES}_FULFILLED`: {
      const { count, page, data = [] } = get(action, 'payload.data', {})
      let updatedData = []

      if (page === 0) {
        updatedData = data
      } else {
        updatedData = [...state.data, ...data]
      }

      return {
        ...state,
        loading: false,
        error: null,
        data: updatedData,
        hasMoreData: updatedData.length < count,
        totalCount: count,
      }
    }

    case `${FETCH_ACTIVE_RESOURCES}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    }
    case `${CHECK_IN_ALL_RESOURCES}_PENDING`: {
      return {
        ...state,
        isCheckingInAllResources: true,
      }
    }

    case `${CHECK_IN_ALL_RESOURCES}_FULFILLED`: {
      let updatedData = checkinAllStatusUpdate(state.data)
      return {
        ...state,
        isCheckingInAllResources: false,
        data: updatedData,
      }
    }

    case `${CHECK_IN_ALL_RESOURCES}_REJECTED`: {
      return {
        ...state,
        isCheckingInAllResources: false,
      }
    }
    case `${CHECK_IN_SINGLE_RESOURCES}_PENDING`: {
      return {
        ...state,
        isCheckingInSingleResources: true,
      }
    }

    case `${CHECK_IN_SINGLE_RESOURCES}_FULFILLED`: {
      const { transactionId } = action.meta

      let updatedData = [...state.data]

      const transactionIndex = updatedData.findIndex(
        session => session.transactionId === transactionId
      )

      if (transactionIndex !== -1) {
        updatedData[transactionIndex] = {
          ...updatedData[transactionIndex],
          status: 'checkInSubmitted',
        }
      }

      return {
        ...state,
        data: updatedData,
        isCheckingInSingleResources: false,
      }
    }

    case `${CHECK_IN_SINGLE_RESOURCES}_REJECTED`: {
      return {
        ...state,
        isCheckingInSingleResources: false,
      }
    }
    case `${CHECK_IN_MULTIPLE_RESOURCES}_PENDING`: {
      return {
        ...state,
        isCheckingInMultipleResources: true,
      }
    }

    case `${CHECK_IN_MULTIPLE_RESOURCES}_FULFILLED`: {
      const { data } = action.payload

      let updatedData = [...state.data]

      data.forEach(transactionId => {
        const transactionIndex = updatedData.findIndex(
          session => session.transactionId === transactionId
        )

        if (transactionIndex !== -1) {
          updatedData[transactionIndex] = {
            ...updatedData[transactionIndex],
            status: 'checkInSubmitted',
          }
        }
      })

      return {
        ...state,
        data: updatedData,
        isCheckingInMultipleResources: false,
      }
    }

    case `${CHECK_IN_MULTIPLE_RESOURCES}_REJECTED`: {
      return {
        ...state,
        isCheckingInMultipleResources: false,
      }
    }

    case `${DISABLE_RESOURCES_IDENTITY}_PENDING`: {
      return {
        ...state,
        isCheckingInAllResources: true,
      }
    }

    case `${DISABLE_RESOURCES_IDENTITY}_FULFILLED`: {
      let updatedData = checkinAllStatusUpdate(state.data)
      return {
        ...state,
        isCheckingInAllResources: false,
        data: updatedData,
      }
    }

    case `${DISABLE_RESOURCES_IDENTITY}_REJECTED`: {
      return {
        ...state,
        isCheckingInAllResources: false,
      }
    }

    default:
      return { ...state }
  }
}
